<label for="checkbox" class="flex items-center cursor-pointer">
  <input
    id="checkbox"
    type="checkbox"
    class="hidden sr-only"
    [disabled]="disabled"
    [checked]="checked"
    (change)="toggle()"
  />
  <div
    class="h-6 w-6 border border-[#A3A3A3] rounded-lg mr-2 flex items-center justify-center"
  >
    <span
      [class.size-3]="checked"
      class="iconify mdi--check text-[#656565] size-0 transition-all duration-300"
    ></span>
  </div>
  <span class="text-ladder-black text-opacity-60 font-semibold"
    ><ng-content></ng-content
  ></span>
</label>
